"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tealium = void 0;
/* eslint-disable no-console */
const library_1 = require("../../core/library");
const loader_1 = require("./loader");
const helper_1 = require("../../core/library/helper");
class Tealium extends library_1.Library {
    constructor(tealiumBaseUrl) {
        super('Tealium', new loader_1.TealiumLoader(tealiumBaseUrl));
        this.recordLink = (data) => window.utag.view(data);
        this.recordView = (data) => window.utag.link(data);
        return (0, helper_1.withLibraryLoadCheck)(this);
    }
}
exports.Tealium = Tealium;
//# sourceMappingURL=index.js.map